import React from 'react';
import { Dialog } from 'pcln-design-system';
import RealTimeVoiceModalInfo from '../../../Voice/RealTimeVoiceModalInfo';
const RealtimeInfoModal = ({
  setShowRealTimeInfoModal,
  setShowVoiceTooltip,
  showRealTimeInfoModal
}) => {
  return React.createElement(Dialog, {
    ariaDescription: 'Realtime Information Modal',
    ariaTitle: 'Information about Realtime Voice Chat',
    borderRadius: '2xl',
    headerColorScheme: 'neutralDarkOnLightest',
    onOpenChange: function (open) {
      setShowRealTimeInfoModal(open);
      setShowVoiceTooltip(open);
      if (!open) {
        localStorage.setItem('userClosedVoiceModeTooltip', 'true');
      }
    },
    overflowX: 'auto',
    overflowY: 'auto',
    scrimColor: 'dark',
    scrimDismiss: true,
    showCloseButton: true,
    size: 'md',
    open: showRealTimeInfoModal
  }, React.createElement(RealTimeVoiceModalInfo, {
    onContinue: function () {
      setShowRealTimeInfoModal(false);
      setShowVoiceTooltip(false);
      localStorage.setItem('userClosedVoiceModeTooltip', 'true');
    }
  }));
};
export default RealtimeInfoModal;